var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "port-connection",
      class: _vm.getContainerClassNames,
      attrs: { id: _vm.data.pt_id }
    },
    [
      _vm.side === "left" && !!_vm.label
        ? _c("div", { staticClass: "port-connection-wrapper" }, [
            _c(
              "div",
              { staticClass: "port-connection-container" },
              [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "p",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "pl-2 pr-2 pt-1 pb-1 port-fiber-label"
                                    },
                                    "p",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(_vm._s(_vm.label))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2895901557
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", { style: { fontSize: "10px" } }, [
                      _vm._v(_vm._s(_vm.label))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.data.connectedFiber
                  ? _c(
                      "p",
                      {
                        staticClass: "pl-2 pr-2 pt-1 pb-1 fiber-port-container",
                        style: {
                          backgroundColor: _vm.getTubeColor(
                            _vm.data.connectedFiber.fb_nr_tube
                          ),
                          color: "white"
                        }
                      },
                      [
                        _vm._v(
                          "\n             " +
                            _vm._s("T" + _vm.data.connectedFiber.fb_nr_tube) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.connectedFiber
                  ? _c(
                      "p",
                      {
                        staticClass: "pl-2 pr-2 pt-1 pb-1 fiber-port-container",
                        style: {
                          backgroundColor: _vm.getFiberColor(
                            _vm.data.connectedFiber.fb_color
                          ),
                          color: "white"
                        }
                      },
                      [
                        _vm._v(
                          "\n             " +
                            _vm._s(
                              "F" + _vm.data.connectedFiber.fb_nr_in_tube
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.connectedPort
                  ? _c(
                      "p",
                      {
                        staticClass: "pl-2 pr-2 pt-1 pb-1",
                        staticStyle: { "border-left": "1px solid grey" }
                      },
                      [
                        _vm._v(
                          "\n             " +
                            _vm._s(
                              "PO" + _vm.data.connectedPort.pt_nr_in_splitter
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.side === "right"
        ? _c("div", { staticClass: "port-circle mr-2" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "port-label-container pl-3 pr-3 pt-1 pb-1",
          class: _vm.getClassNames
        },
        [_c("p", [_vm._v(_vm._s(_vm.getPortLabel))])]
      ),
      _vm._v(" "),
      _vm.side === "left"
        ? _c("div", { staticClass: "port-circle ml-2" })
        : _vm._e(),
      _vm._v(" "),
      _vm.side === "right" && !!_vm.label
        ? _c("div", { staticClass: "port-connection-wrapper" }, [
            _c(
              "div",
              { staticClass: "port-connection-container" },
              [
                _vm.data.connectedFiber
                  ? _c(
                      "p",
                      {
                        staticClass: "pl-2 pr-2 pt-1 pb-1 fiber-port-container",
                        style: {
                          backgroundColor: _vm.getFiberColor(
                            _vm.data.connectedFiber.fb_color
                          ),
                          color: "white"
                        }
                      },
                      [
                        _vm._v(
                          "\n             " +
                            _vm._s(
                              "F" + _vm.data.connectedFiber.fb_nr_in_tube
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.connectedFiber
                  ? _c(
                      "p",
                      {
                        staticClass: "pl-2 pr-2 pt-1 pb-1 fiber-port-container",
                        style: {
                          backgroundColor: _vm.getTubeColor(
                            _vm.data.connectedFiber.fb_nr_tube
                          ),
                          color: "white"
                        }
                      },
                      [
                        _vm._v(
                          "\n             " +
                            _vm._s("T" + _vm.data.connectedFiber.fb_nr_tube) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.connectedPort
                  ? _c(
                      "p",
                      {
                        staticClass: "pl-2 pr-2 pt-1 pb-1",
                        staticStyle: { "border-right": "1px solid grey" }
                      },
                      [
                        _vm._v(
                          "\n             " +
                            _vm._s(
                              "PO" + _vm.data.connectedPort.pt_nr_in_splitter
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "p",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "pl-2 pr-2 pt-1 pb-1 port-fiber-label"
                                    },
                                    "p",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(_vm._s(_vm.label))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2895901557
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", { style: { fontSize: "10px" } }, [
                      _vm._v(_vm._s(_vm.label))
                    ])
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35682c7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35682c7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/Connection.vue
// module id = null
// module chunks = 